<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path d="M0.25 13.6663V4.33301H3.25V13.6663H0.25ZM5.5 13.6663V0.333008H8.5V13.6663H5.5ZM10.75 13.6663V8.33301H13.75V13.6663H10.75Z" fill="" :class="containerClass" />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
